var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-btn",
        {
          staticClass: "blue--text",
          attrs: { color: "accent-2" },
          on: {
            click: function($event) {
              _vm.dialog = true
            }
          }
        },
        [
          _c("v-icon", [_vm._v("mdi-currency-usd")]),
          _vm._v("Transactions\n              ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { scrollable: "" },
          on: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              _vm.dialog = false
            }
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "mdi-filter",
                      label: "Type to filter"
                    },
                    model: {
                      value: _vm.filter,
                      callback: function($$v) {
                        _vm.filter = $$v
                      },
                      expression: "filter"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticStyle: { "min-height": "69vh" } },
                [
                  _vm.allTransactionsByDate
                    ? _c(
                        "v-data-table",
                        {
                          attrs: {
                            search: _vm.filter,
                            "items-per-page": 50,
                            headers: _vm.headers,
                            items: _vm.allTransactionsByDate,
                            "item-key": "id"
                          },
                          on: { "current-items": _vm.getFiltered },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "item.price",
                                fn: function(ref) {
                                  var item = ref.item
                                  return [
                                    _c("span", [
                                      _vm._v("$" + _vm._s(item.price) + " ")
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3148874288
                          )
                        },
                        [
                          _vm._v(" "),
                          _c("template", { slot: "body.append" }, [
                            _c("tr", { staticClass: "pink--text" }, [
                              _c("th", { staticClass: "title" }, [
                                _vm._v("Total")
                              ]),
                              _vm._v(" "),
                              _c("th", { staticClass: "title" }, [
                                _vm._v("$" + _vm._s(_vm.total))
                              ])
                            ])
                          ])
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _vm._v("Press  "),
                      _c("v-icon", [_vm._v("mdi-keyboard-esc")]),
                      _vm._v(" to close this card")
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v("Close")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }